import { connect } from 'react-redux'
import addUserGroupSelector from './addUserGroupSelector'
import { sagaActions } from '../../../../sagas'
import AddUserGroup from './AddUserGroup'

export default connect(
  addUserGroupSelector,
  {
    requestSetUserGroupPermissionInHomeLayout: sagaActions.requestSetUserGroupPermissionInHomeLayout
  }
)(AddUserGroup)
